import { useParams } from 'react-router-dom';
import { DateInput, useFormContext } from 'framework/form';
import type { InviteUserFormData } from './types';
import { TextInput } from 'framework/form';
import { Stack } from '@mui/material';
import ClientPortalInviteUserContactDropdown from './ClientPortalInviteUserContactDropdown';

const ClientPortalInviteUserForm = () => {
  const { id = '' } = useParams<Dictionary<string>>();
  const { data = {} } = useFormContext();
  const { selectedContactId } = data as InviteUserFormData;

  return (
    <Stack spacing={2} pb={4}>
      <ClientPortalInviteUserContactDropdown accountAlias={id} selectedContactId={selectedContactId} />

      {selectedContactId && (
        <>
          <TextInput source="firstName" label="First name" />
          <TextInput source="lastName" label="Last name" />
          <TextInput source="email" label="Email" />
          <DateInput source="accessUntil" label="Access until" maxDate={data.budgetEndDate} />
        </>
      )}
    </Stack>
  );
};

export default ClientPortalInviteUserForm;
